const SalesChannelsBox = ({ salesChannels, handleSalesChannelsChange, product, selectedSalesChannels = null,edit=false }) => {
    // All the saleschannel types that will be shown to the user in the product page
    const validSalesChannelsTypes = [
        1, // WooCommerce
    ];
    const validSalesChannels = salesChannels.filter(salesChannel => validSalesChannelsTypes.includes(salesChannel.type));

    return (
        <div className="whiteBox p-5 h-100">
            <div className="d-flex flex-column h-100">
                <h4 className="inputTitle mb-4">Verkoopkanaal</h4>
                <div className="d-flex h-100 flex-column">
                    {validSalesChannels.length > 0 ? (
                        validSalesChannels.map((salesChannel, index) => (
                            <div
                                key={index}
                                className="d-flex flex-row mb-3 slidersSellchannel justify-content-between align-items-center"
                            >
                                <h6 className="switchText mb-0">
                                    {salesChannel.sales_channel_name}
                                </h6>
                                <label className="defaultSwitch ms-3">
                                    <input
                                        type="checkbox"
                                        checked={selectedSalesChannels?.find(selected => selected === salesChannel.sales_channel_id)}
                                        value={salesChannel.sales_channel_id ?? ''}
                                        onChange={handleSalesChannelsChange}
                                    />
                                    <span className="sliderActiveProduct round"></span>
                                </label>
                            </div>
                        ))
                    ) : (
                        <p>Er zijn nog geen verkoopkanalen gemaakt.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SalesChannelsBox;
